import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { CostantiStorage } from '../costanti';

@Injectable()
export class AggiornamentoDatiPendingGuard implements CanActivateChild {
  constructor(
    private router: Router,
    private fuseConfig: FuseConfigService
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const loginRe = /^\/(login)(\/|$)/;
    if (!localStorage.getItem(CostantiStorage.AGGIORNAMENTO_DATI_PENDING)) {
      return true;
    }
    const path = state.url.split(/[?#]/)[0];
    if (/^\/(login|logout)(\/|$)/.test(path)) {
      return true;
    }
    // NavigationStart ha gia' resettato il layout al default (menu visibile): rinasconde
    this.fuseConfig.setConfig({
      layout: {
        navbar: { hidden: true },
        navigation: { hidden: true },
        toolbar: { hidden: true },
        footer: { hidden: true }
      }
    });
    // gia' su /login: false ripristina la barra indirizzi (UrlTree verso stessa URL verrebbe ignorato)
    if (loginRe.test(this.router.url.split(/[?#]/)[0])) {
      return false;
    }
    return this.router.parseUrl('/login');
  }
}
